export const SITE_URL = "https://platform.mindbodylife.pro";
export const JOIN_URL = "https://platform.mindbodylife.pro";

export const IMAGES = {
  logo: "https://static.prod-images.emergentagent.com/jobs/9ee28b18-f03e-4f81-aaba-318a31c2f25b/images/9fc944ec27e5a9ffe790a25b2c22e8354d063aef95ee4de7aebb3287d4480b8f.jpeg",
  heroAthlete: "https://static.prod-images.emergentagent.com/jobs/9ee28b18-f03e-4f81-aaba-318a31c2f25b/images/cc96222dc07b5704dbdcbecf28f07810ceee4c552bf53b334012f66f5ce5afcf.jpeg",
  grainTexture: "https://static.prod-images.emergentagent.com/jobs/9ee28b18-f03e-4f81-aaba-318a31c2f25b/images/6851e9655200a72af641d439b303c431c80271c22217c850265bead78b72419c.jpeg",
  founder: "https://static.prod-images.emergentagent.com/jobs/9ee28b18-f03e-4f81-aaba-318a31c2f25b/images/9ea3c64f52ed1cb5db8a16aa816eb7bd3e57b94de4fc308c3f160bef045f05a7.jpeg",
  gym1: "https://images.unsplash.com/photo-1770513649465-2c60c8039806?crop=entropy&cs=srgb&fm=jpg&q=85",
  gym2: "https://images.unsplash.com/photo-1550345332-09e3ac987658?crop=entropy&cs=srgb&fm=jpg&q=85",
  gym3: "https://images.unsplash.com/photo-1605296867724-fa87a8ef53fd?crop=entropy&cs=srgb&fm=jpg&q=85",
  gym4: "https://images.unsplash.com/photo-1625398511086-9482aa18c95c?crop=entropy&cs=srgb&fm=jpg&q=85",
  breathe1: "https://images.unsplash.com/photo-1681977151572-78a1ba5f8627?crop=entropy&cs=srgb&fm=jpg&q=85",
  breathe2: "https://images.unsplash.com/photo-1710527304331-4186db4ee708?crop=entropy&cs=srgb&fm=jpg&q=85",
  nutrition1: "https://images.unsplash.com/photo-1569246294372-ed319c674f14?crop=entropy&cs=srgb&fm=jpg&q=85",
  nutrition2: "https://images.unsplash.com/photo-1623428187969-5da2dcea5ebf?crop=entropy&cs=srgb&fm=jpg&q=85",
  dumbbell1: "https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&q=85",
  dumbbell2: "https://images.unsplash.com/photo-1734630341082-0fec0e10126c?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const NAV_LINKS = [
  { label: "Active360", href: "#active360" },
  { label: "Platform", href: "#platform" },
  { label: "Philosophy", href: "#philosophy" },
  { label: "Founder", href: "#founder" },
];

export const ECOSYSTEM = [
  { key: "mind", title: "MIND", desc: "Mental strength, focus, discipline, motivation & positive habits.", icon: "Brain" },
  { key: "body", title: "BODY", desc: "Strength, fitness, mobility, conditioning & physical performance.", icon: "Dumbbell" },
  { key: "gut", title: "GUT", desc: "Better eating habits, nutrition awareness & digestive wellness.", icon: "Leaf" },
  { key: "lifestyle", title: "LIFESTYLE", desc: "Daily routine, sleep, habits, stress management & long-term wellness.", icon: "Heart" },
];

export const OTT_COACHES = [
  { title: "Fitness Coach", icon: "Dumbbell", img: IMAGES.gym3 },
  { title: "Nutrition Guide", icon: "Salad", img: IMAGES.nutrition1 },
  { title: "Mindset Mentor", icon: "Brain", img: IMAGES.gym4 },
  { title: "Lifestyle Coach", icon: "Sunrise", img: IMAGES.breathe2 },
  { title: "Breathing Expert", icon: "Wind", img: IMAGES.breathe1 },
  { title: "Strength Coach", icon: "Flame", img: IMAGES.dumbbell2 },
  { title: "Wellness Community", icon: "Users", img: IMAGES.gym2 },
];

export const PROGRAM_ITEMS = [
  { n: "01", title: "365 Days of Workouts", desc: "Structured guidance for weight loss, strength, mobility & conditioning — at home, gym or anywhere.", icon: "Dumbbell" },
  { n: "02", title: "50+ Diet Charts", desc: "Structured nutrition systems for weight management, transformation & sustainable eating.", icon: "Salad" },
  { n: "03", title: "30 Lifestyle Videos", desc: "Daily routine, sleep, energy management & lifestyle discipline for long-term consistency.", icon: "Sunrise" },
  { n: "04", title: "30 Mindset Videos", desc: "Motivation, discipline, focus, goal setting & transformation psychology.", icon: "Brain" },
  { n: "05", title: "24 Breathing Exercises", desc: "Guided breathing techniques for relaxation, stress management & recovery.", icon: "Wind" },
  { n: "06", title: "10 Spot Cardio Drills", desc: "Quick, effective cardio you can do at home, office, travel or outdoors.", icon: "Zap" },
  { n: "07", title: "10 Dumbbell Workouts", desc: "Build strength & functional fitness from the comfort of your home.", icon: "Flame" },
  { n: "08", title: "Expert Podcasts", desc: "Hundreds of videos & podcasts from wellness professionals across every topic.", icon: "Mic2" },
];

export const COMPARISON_ROWS = [
  { feature: "Cost", active360: "₹1 / day (₹365/yr)", trainer: "₹3,000 – ₹15,000/mo", app: "₹500 – ₹2,000/mo" },
  { feature: "Workouts", active360: "365 days, structured", trainer: "Session-based", app: "Random / generic" },
  { feature: "Nutrition Guidance", active360: "50+ diet systems", trainer: "Sometimes extra cost", app: "Rarely included" },
  { feature: "Mindset & Lifestyle", active360: "30 + 30 videos", trainer: "Not included", app: "Not included" },
  { feature: "Breathing & Recovery", active360: "24 exercises", trainer: "Not included", app: "Not included" },
  { feature: "Availability", active360: "Anytime, anywhere", trainer: "Fixed schedule", app: "Anytime" },
];

export const MISSION_ITEMS = [
  { title: "Making Fitness Affordable", desc: "Quality health guidance should not be limited to a privileged few." },
  { title: "Making Wellness Accessible", desc: "Access your transformation journey anytime and anywhere." },
  { title: "365 Days of Transformation", desc: "Health isn't something you do occasionally — it's a daily practice." },
  { title: "Delivering Structured Systems", desc: "No more random workouts. No more confusion. Follow a system." },
  { title: "Building Better Habits", desc: "Small daily actions create extraordinary long-term results." },
  { title: "Creating Mass Transformation", desc: "Our mission: help more people live healthier lives." },
];

export const FOUNDER_CREDENTIALS = [
  { label: "International Athletic Experience", icon: "Trophy" },
  { label: "18+ Certifications & Diplomas", icon: "GraduationCap" },
  { label: "16+ Years of Industry Experience", icon: "Flame" },
  { label: "4,000+ Transformation Stories", icon: "Users" },
];
